import { IGetAllUsers } from "../../models/response/IUserResponse";


export const getAllUserState: IGetAllUsers = {
    TotalRecords: 30,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 100,
    Users: []
}